import { useAppContext } from '@/core';
import { useMemo } from 'react';

export const useUserPermissions = () => {
  const { userData } = useAppContext();

  const userPermissions = useMemo(() => {
    if (!userData?.permissions) {
      return [];
    }
    return userData.permissions;
  }, [userData?.permissions]);

  const hasPermission = (permission: string | undefined): boolean => {
    if (!permission) return true; // No permission required
    if (!userPermissions.length) return false; // No permissions available
    return userPermissions.includes(permission);
  };

  const hasAnyPermission = (permissions: (string | undefined)[]): boolean => {
    return permissions.some((permission) => hasPermission(permission));
  };

  const hasAllPermissions = (permissions: (string | undefined)[]): boolean => {
    return permissions.every((permission) => hasPermission(permission));
  };

  return {
    userPermissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
};
